import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectBalancingSkipTrashingFactor } from "../../../balancingSelectors/selectBalancingConstants";
import { IdResource } from "../../../constants/IdResource";
import { selectContractById } from "../../../selectors/selectContractInfo";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { utilSkipProcess } from "../../../utils/utilSkipProcess";
import { utilTime } from "../../../utils/utilTime";
import { actionBeginBuyWithGoldProcess } from "../../buy-with-gold/actionBuyWithGold";
import { actionContractSkip, TypeActionContractInfo, } from "../actionContractInfo";
export var epicMarketContractRequestSkip = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionContractInfo.RequestSkip), switchMap(function (action) {
        var state = state$.value;
        var playerGoldInfo = selectInventoryResourceInfo(state, IdResource.Gold);
        var remainingTime = selectContractById(state, action.contractId).remainingTime;
        var timeLeft = utilTime.secondsLeftTill(remainingTime);
        var costToSkipTrashContract = selectBalancingSkipTrashingFactor();
        var goldRequired = utilSkipProcess.calculateCostToSkipProcess(timeLeft, costToSkipTrashContract);
        return of(actionBeginBuyWithGoldProcess(playerGoldInfo.amount || Long.ZERO, Long.fromValue(goldRequired), actionContractSkip(action.contractId, goldRequired)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicMarketContractRequestSkip.ts
// module id = 2001
// module chunks = 3